/* eslint-disable import/no-anonymous-default-export */
import LoanDisbursementActionTypes from './loan-disbursement.types';
import { docodeHexResponse } from '../../_common/common.utils';

const INITIAL_STATE = {
	// GET LOAN DISBURSEMENT LIST RESPONSE
	getLoanDisbursementListResponse: null,

	// GET OFFICER BRANCH LIST RESPONSE
	getOfficerBranchListResponse: null,
	getOfficerBranchListArr: [],

	// FETCH ALL ECONOMIC ACTIVITY RESPONSE
	fetchAllEconomicActivitysResponse: null,
	fetchAllEconomicActivitysArr: [],
};

export default (state = INITIAL_STATE, action: { type: any; payload: any }) => {
	switch (action.type) {
		/** *********************  START GET LOAN DISBURSEMENT REPORT DETAILS  ******************** */
		case LoanDisbursementActionTypes.GET_LOAN_DISBURSEMENT_LIST_SUCCESS:
			return {
				...state,
				getLoanDisbursementListResponse: action.payload,
			};

		case LoanDisbursementActionTypes.GET_LOAN_DISBURSEMENT_LIST_FAILURE:
			return { ...state, getLoanDisbursementListResponse: action.payload };

		case LoanDisbursementActionTypes.GET_LOAN_DISBURSEMENT_LIST_RESPONSE_CHANGED:
			return { ...state, getLoanDisbursementListResponse: null };
		/** *********************  END GET LOAN DISBURSEMENT REPORT LIST ******************** */

		/** *********************  START GET OFFICER BASED ON BRANCH DETAILS  ******************** */
		case LoanDisbursementActionTypes.GET_OFFICER_BRANCH_LIST_SUCCESS:
			return {
				...state,
				getOfficerBranchListResponse: action.payload,
				getOfficerBranchListArr: docodeHexResponse(
					action.payload,
					'GetOfficerListBranchKey',
				),
			};

		case LoanDisbursementActionTypes.GET_OFFICER_BRANCH_LIST_FAILURE:
			return { ...state, getOfficerBranchListResponse: action.payload };

		case LoanDisbursementActionTypes.GET_OFFICER_BRANCH_LIST_RESPONSE_CHANGED:
			return { ...state, getOfficerBranchListResponse: null };
		/** *********************  END GET OFFICER BASED ON BRANCH LIST ******************** */

		/** ***************** FETCH ALL PRODUCT TYPE START *********************** */
		case LoanDisbursementActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_SUCCESS:
			return {
				...state,
				fetchAllEconomicActivitysResponse: action.payload,
				fetchAllEconomicActivitysArr: docodeHexResponse(
					action.payload,
					'FetchAllEconomicActivityTypesKey',
				),
			};

		case LoanDisbursementActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_FAILURE:
			return { ...state, fetchAllEconomicActivitysResponse: action.payload };

		case LoanDisbursementActionTypes.FETCH_ALL_ECONOMIC_ACTIVITY_RESPONSE_CHANGED:
			return { ...state, fetchAllEconomicActivitysResponse: null };
		/** ***************** FETCH ALL PRODUCT TYPE END *********************** */
		default:
			return state;
	}
};
